// pages/ControlUsersPage.jsx
import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ControlUserCard from './ControlUserCard';

const ControlUsersPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header with Back Button */}
      <div className="mb-8">
        <button
          onClick={() => navigate('/dev-admin')}
          className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 mb-4 transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
          <span>Back to Dashboard</span>
        </button>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">User Management</h1>
        <p className="text-gray-600">Manage user accounts, permissions, and profiles</p>
      </div>
      
      {/* Control User Card - Full functionality */}
      <ControlUserCard />
    </div>
  );
};

export default ControlUsersPage;
